export const PeriodOptionDescriptions = {
  week: '週一到週日',
  month: '1-31 日',
  firstHalfOfMonth: '1-15 日',
  secondHalfOfMonth: '16-31 日',
};
